module.exports = __webpack_public_path__ + "static/media/window.72e35f63.svg";